import styled from '@emotion/styled';

import { OutlineButton } from '@/components/common/Button/style';
import { TablePanel } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export { TablePanel };

export const Container = styled.main`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 8rem;
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
`;
export const ContentItems = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	width: 100%;
	margin: 0 auto;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	a {
		color: ${(props) => props.theme.colors.primary400};
		text-decoration: underline;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: ${(props) => props.theme.ui.lineHeight.body};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		margin-left: 1rem;
	}
`;
export const Table = styled.div`
	display: grid;
	grid-auto-rows: minmax(40px, auto);
	white-space: nowrap;
	overflow: auto;
	gap: 0.2rem;
	&.table1 {
		grid-template-columns: 1fr 1fr 2fr;
		.item1 {
			grid-column-start: 1;
			grid-column-end: 3;
		}
		.item2 {
			grid-row-start: 2;
			grid-row-end: 6;
		}
	}
	&.table2 {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-template-areas:
			'item1 item2 item3 item4'
			'item5 item6 item7 item8';
		@media screen and (max-width: 900px) {
			grid-template-columns: 1fr 4fr;
			grid-template-areas:
				'item1 item5'
				'item2 item6'
				'item3 item7'
				'item4 item8';
		}
	}
`;

export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 10px 15px;
	text-align: left;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: ${(props) => props.theme.lineHeight.normal};
	&.center {
		justify-content: center;
	}
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 2rem 1.6rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	&.point {
		color: ${(props) => props.theme.colors.primary400};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
		text-align: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;

export const TableCellLayout = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 1.2rem;
`;

export const ContentListLayout = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: start;
	gap: 0.4rem;
`;

export const ContentTitleSub = styled.p`
	color: #212529;
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 600;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;

export const ContentDescription = styled.p`
	color: var(--Colors-Font---color-font-darker, #212529);
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 400;
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	white-space: pre-line;
`;

export const ManuscriptGuide = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.6rem;
	width: 100%;
`;

export const ManuscriptGuideLine = styled.p`
	width: 100%;
	color: #212529;
	font-size: 1.8rem;
	font-weight: 500;
	line-height: 1.7;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
	white-space: pre-line;

	&.title {
		font-size: 2.2rem;
		font-weight: 700;
		line-height: 1.5;
	}

	&.subtitle {
		font-size: 2rem;
		font-weight: 700;
		line-height: 1.5;
	}

	&.section {
		font-size: 1.9rem;
		font-weight: 700;
		line-height: 1.6;
	}

	&.note {
		font-size: 1.7rem;
		font-weight: 600;
		line-height: 1.6;
	}

	&.small {
		font-size: 1.6rem;
		line-height: 1.6;
	}

	&.left {
		text-align: left;
	}

	&.spacer {
		height: 1.4rem;
		font-size: 0;
		line-height: 0;
	}
`;

export const Button = styled(OutlineButton)`
	width: 100%;
`;
